import React, { Fragment } from "react";
import MetaTags from "react-meta-tags";
import LayoutOne from "../layouts";
import Breadcrumb from "../components/UI/breadcrumb";

const About = () => {
    return (
        <Fragment>
            <MetaTags>
                <title>Adaptive Systems LLC | Terms of Service</title>
                <meta
                    name="description"
                    content=""
                />
            </MetaTags>
            <LayoutOne>
                <Breadcrumb title="Terms of Service" />

                <div className="container pt--60 pb--60">
                    <h4>Adaptive Systems LLC</h4>
                    <h4>Effective Date: 07 july 2025 </h4>

                    <p>These Terms of Service (“Agreement”) govern your use of the services provided by Adaptive Systems LLC (“we,” “us,” “our”), including internet, cable TV, and home phone services (the “Services”). By subscribing to, accessing, or using our Services, you agree to be bound by these Terms, as well as any additional terms, policies, or agreements referenced herein. If you do not agree to these terms, you may not use our Services.</p>

                    <h4>1. Services Provided</h4>
                    <p>Adaptive Systems LLC provides the following Services to residential and commercial customers:</p>

                    <ul>
                        <li>Internet Services</li>
                        <li>Cable TV Services</li>
                        <li>Home Phone Services</li>
                    </ul>

                    <p>These Services are subject to availability in your area and may be modified or discontinued at our discretion. We reserve the right to update, modify, or terminate the Services at any time.</p>



                    <h4>2. Eligibility</h4>
                    <p>To subscribe to and use our Services, you must:</p>
                    <ul>
                        <li>Be at least 18 years of age, or have a parent or guardian’s consent if under 18.</li>
                        <li>Be a resident of a geographic area where our Services are offered.</li>
                        <li>Provide accurate and complete information when subscribing.</li>
                        <li>Maintain and update your information as necessary.</li>
                    </ul>

                    <h4>3. Account Registration and Security</h4>
                    <p>When you sign up for our Services, you agree to:</p>

                    <ul>
                        <li>Provide accurate, current, and complete information during registration.</li>
                        <li>Maintain the confidentiality of your account credentials (username, password, etc.).</li>
                        <li>Be responsible for all activities that occur under your account, including any charges.</li>
                    </ul>

                    <p>You must notify us immediately of any unauthorized use of your account or any security breach.</p>


                    <h4>4. Payment Terms</h4>
                    <ul>
                        <li>Billing & Payment: By subscribing, you agree to pay all fees and charges associated with your use of the Services. Billing cycles, rates, and charges are outlined in your service agreement and/or on our website.</li>
                        <li>Late Payment: If payment is not received by the due date, we may suspend or terminate your Services until full payment is made. Late fees or other penalties may apply.</li>
                        <li>Changes to Fees: We reserve the right to modify service fees at any time, with advance notice.</li>
                    </ul>


                    <h4>5. Use of Services</h4>
                    <p>You agree to use our Services legally and may not:</p>
                    <ul>
                        <li>Violate intellectual property rights (e.g., unauthorized sharing of copyrighted content).</li>
                        <li>Interfere with or disrupt our network or Services.</li>
                        <li>Use the Services to transmit harmful or malicious content (e.g., viruses, malware).</li>
                        <li>Engage in any activity that could degrade service quality for other users.</li>
                    </ul>
                    <p>We reserve the right to terminate or suspend your Services if you violate these terms.</p>


                    <h4>6. Service Availability & Interruptions</h4>
                    <p>We strive to provide uninterrupted service, but we do not guarantee continuous, error-free access. Service interruptions may occur due to maintenance, network issues, or unforeseen events. While we work to restore service quickly, we are not liable for any inconvenience, data loss, or damages caused by interruptions.</p>

                    <h4>7. Equipment & Installation</h4>
                    <ul>
                        <li>Customer Equipment: You may be required to use specific equipment (e.g., modem, router, set-top box). You may lease equipment from us or use your own if compatible.</li>
                        <li>Installation: We provide installation services as part of service setup. You must grant access to your property for installation. Any damage to property not due to our negligence is the customer’s responsibility.</li>
                    </ul>

                    <h4>8. Termination & Suspension of Services</h4>
                    <p>You or we may terminate the Services at any time.</p>
                    <ul>
                        <li>You may cancel by contacting customer support. Any outstanding charges (including termination fees, if applicable) must be paid.</li>
                        <li>We may suspend or terminate Services without notice if:
                            <ul>
                                <li>You fail to pay your bills.</li>
                                <li>You violate any part of these Terms.</li>
                                <li>We are required to do so by law or a third-party claim.</li>
                            </ul>
                        </li>
                    </ul>


                    <h4>9. Privacy & Data Protection</h4>
                    <p>Your privacy is important to us. Please review our Privacy Policy for details on how we collect, use, and protect your personal data. By using our Services, you consent to data collection as described in the Privacy Policy.</p>


                    <h4>10. Limitations of Liability</h4>
                    <p>To the fullest extent permitted by law, Adaptive Systems LLC is not liable for:</p>
                    <ul>
                        <li>Any direct, indirect, incidental, special, or punitive damages arising from your use of the Services.</li>
                        <li>Any loss of data, service interruptions, or issues beyond our control (e.g., internet outages, force majeure events, unauthorized account access).</li>
                    </ul>

                    <p>Our liability is limited to the total amount you have paid for Services in the 12 months preceding any claim.</p>

                    <h4>11. Indemnification</h4>
                    <p>You agree to indemnify, defend, and hold harmless Adaptive Systems LLC, its affiliates, employees, and licensors from any claims, damages, or expenses arising from:</p>
                    <ul>
                        <li>Your use of our Services.</li>
                        <li>Your violation of these Terms.</li>
                        <li>Any infringement of another party’s rights.</li>
                    </ul>


                    <h4>12. Amendments to Terms</h4>
                    <p>We may modify these Terms of Service at any time. Changes will be posted on our website and take effect immediately upon posting. You are responsible for reviewing these Terms periodically. Continued use of our Services after updates constitutes your acceptance of the changes.</p>

                    <h4>13. Governing Law</h4>
                    <p>This Agreement is governed by the laws of Virginia, without regard to conflict of law principles. Any disputes arising from these Terms will be resolved in state or federal courts in Fairfax County, Virginia.</p>



                    <h4>14. Dispute Resolution & Arbitration</h4>
                    <p>All disputes or claims related to these Terms will be resolved through binding arbitration under the American Arbitration Association rules. Disputes will be conducted on an individual basis, not as a class action.</p>

                    <h4>15. Miscellaneous</h4>

                    <p>Entire Agreement: These Terms, along with our Privacy Policy and any applicable agreements, constitute the entire agreement between you and Adaptive Systems LLC.</p>


                    <p>Severability: If any provision of these Terms is found unenforceable, the remaining provisions will remain in full force.</p>


                    <p>No Waiver: Our failure to enforce any provision does not waive our right to enforce it in the future.</p>


                    <h4>16. Contact Us</h4>
                    <p>For any questions or concerns about these Terms, please contact us:</p>
                    <p>Email: info@adaptivesystems-llc.com</p>
                    <p>Mailing Address: 2420 Kates Pl ,Prosper, TX 75078</p>








                </div>
            </LayoutOne>
        </Fragment>
    );
};

export default About;
